<script lang="ts" setup>
definePage({
	name: "school.teacher-search.general-search",
});
</script>

<template>
	<div id="general-search"></div>
</template>
